import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

const hasErrors = fieldsError => Object
  .keys(fieldsError)
  .some(field => typeof fieldsError[field] === 'object' ? hasErrors(fieldsError[field]) : fieldsError[field])

const SubmitButton = ({ form, text, type, loading, cssClass, fieldsOutsideFormTouched, onClick }) => (
  <Button
    onClick={onClick}
    disabled={hasErrors(form.getFieldsError())}
    type={type}
    loading={loading}
    htmlType="submit"
    className={cssClass}
  >
    {text}
  </Button>
)

SubmitButton.propTypes = {
  form: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  loading: PropTypes.bool,
}

SubmitButton.defaultProps = {
  type: "primary"
}

export default SubmitButton
